import type { RouteParams } from "vue-router";

import { Schulform } from "@core/asd/types/schule/Schulform";
import { BenutzerKompetenz } from "@core/core/types/benutzer/BenutzerKompetenz";
import { ServerMode } from "@core/core/types/ServerMode";
import type { FaecherListeManager } from "@ui/ui/manager/kataloge/FaecherListeManager";

import { RouteSchuleMenuGroup } from "../../RouteSchuleMenuGroup";
import type { FaecherAuswahlProps } from "~/components/schule/kataloge/faecher/FaecherAuswahlProps";
import type { RouteApp } from "~/router/apps/RouteApp";
import { routeFaecherDaten } from "~/router/apps/schule/kataloge/faecher/RouteFaecherDaten";
import { RouteAuswahlNode } from "~/router/RouteAuswahlNode";
import type { RouteNode } from "~/router/RouteNode";

import { RouteDataFaecher } from "./RouteDataFaecher";
import { routeFaecherGruppenprozesse } from "./RouteFaecherGruppenprozesse";
import { routeFaecherNeu } from "./RouteFaecherNeu";
import { routeFaecherStundenplan } from "./stundenplan/RouteFaecherStundenplan";

const FaecherAuswahl = () => import("~/components/schule/kataloge/faecher/FaecherAuswahl.vue");
const FaecherApp = () => import("~/components/schule/kataloge/faecher/FaecherApp.vue");

export class RouteFaecher extends RouteAuswahlNode<FaecherListeManager, RouteDataFaecher, RouteApp> {

	public constructor() {
		super(Schulform.values(), [BenutzerKompetenz.KATALOG_EINTRAEGE_ANSEHEN, BenutzerKompetenz.KATALOG_EINTRAEGE_AENDERN], "schule.faecher", String.raw`schule/faecher/:id(\d+)?`, FaecherApp, FaecherAuswahl, new RouteDataFaecher());
		super.mode = ServerMode.STABLE;
		super.text = "Fächer";
		super.menugroup = RouteSchuleMenuGroup.KATALOGE;
		super.children = [
			routeFaecherDaten,
			routeFaecherStundenplan,
			routeFaecherGruppenprozesse,
			routeFaecherNeu,
		];
		super.defaultChild = routeFaecherDaten;
		super.updateIfTarget = this.doUpdateIfTarget;
		super.getAuswahlListProps = (props) => (<FaecherAuswahlProps>{
			...props,
		});
	}

	protected doUpdateIfTarget = async (to: RouteNode<any, any>, to_params: RouteParams, from: RouteNode<any, any> | undefined) => {
		if (!this.data.manager.hasDaten()) {
			return;
		}
		return this.getRouteSelectedChild();
	};
}

export const routeFaecher = new RouteFaecher();
